export default "__VITE_ASSET__Chdp6tlA__"